module.exports = __webpack_public_path__ + "static/media/QCCrest.c35947cb.png";